import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import * as Styled from './CreditOptionsBanner.styles'

class CreditOptionsBanner extends PureComponent {
  render() {
    const { periodDuration, periodType, apr, 'data-test': dataTest } = this.props

    const timeToPay = periodDuration
      ? `Pay no interest when you pay your full balance within ${periodDuration} ${periodType}`
      : 'Spread the cost with an Argos Card'

    return (
      <>
        <div>
          <BannerHeadingContent timeToPay={timeToPay} />
          <Styled.InterestRate>
            <p>
              Representative
              <strong className='interest'> {apr}% APR </strong>
              variable
            </p>
          </Styled.InterestRate>
        </div>
        <BottomLabel dataTest={dataTest} />
      </>
    )
  }
}

CreditOptionsBanner.propTypes = {
  periodDuration: PropTypes.number,
  periodType: PropTypes.string,
  apr: PropTypes.number,
  'data-test': PropTypes.string
}
CreditOptionsBanner.defaultProps = {
  'data-test': 'credit-options-banner'
}

const BannerHeadingContent = ({ timeToPay }) => (
  <Styled.BannerHeading>
    <p>{`${timeToPay}`}</p>
  </Styled.BannerHeading>
)

const BottomLabel = ({ dataTest }) => {
  const text = 'Credit is subject to status. Ts & Cs apply.'
  return (
    <Styled.BottomLabel data-test={`${dataTest}-label`}>
      <span>{text}</span>
    </Styled.BottomLabel>
  )
}

export default CreditOptionsBanner

export { BottomLabel }
